import React, { useState } from "react";
import { ToggleButtonGroup, Typography } from "@mui/material";
import StyledToggleButton from "shared/ui/ToggleButton";

export type SurveyTabStatus = "ALL" | "ACTIVE" | "INACTIVE";

interface SurveysTabsProps {
  onStatusChange: (status: string) => void;
}

const STATUSES: SurveyTabStatus[] = ["ALL", "ACTIVE", "INACTIVE"];

const SurveysTabs: React.FC<SurveysTabsProps> = ({ onStatusChange }) => {
  const [activeStatus, setActiveStatus] = useState<SurveyTabStatus>("ACTIVE");

  const handleTabChange = (activeStatus: SurveyTabStatus | null) => {
    if (!activeStatus) return;
    setActiveStatus(activeStatus);
    onStatusChange(activeStatus);
  };

  return (
    <ToggleButtonGroup
      value={activeStatus}
      exclusive
      onChange={(_, value) => handleTabChange(value)}
      sx={{
        minWidth: "210px",
        border: "1px solid #1976d2",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {STATUSES.map((status) => (
        <StyledToggleButton
          key={status}
          value={status}
          selected={activeStatus === status}
          sx={{
            border: "none !important",
            borderRadius: 0,
            width: 100,
          }}
        >
          <Typography>{status}</Typography>
        </StyledToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SurveysTabs;
